import { useSelector } from "react-redux";
import BankDetails from "../../../../../components/_utils/AccountCreationComponents/BankDetails";
import CommonBankLogo from "../../../../../components/_utils/CommonBankLogo";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import { linkIdentifier } from "../../../../../utils/linkIdentifier";
import globalText from "../../../../../utils/globalText";

const ReimbursementEditConfirm = (props) => {
  const verification = useSelector(
    (state) => state.sharedResources.verifyBankAccountData,
  );
  const verifiedDetails = verification?.verification_details?.[0];
  const previewPayload = {
    ...props?.payload,
    virtual_account_type:
      props?.manualVirtualAccount || verifiedDetails?.is_virtual === "Y"
        ? props?.manualVirtualAccount
          ? "manual"
          : "automated"
        : props?.payload?.virtual_account_type,
  };

  return (
    <div className="beneBank_Main_edit">
      <CommonLayout>
        <BankDetails
          payload={previewPayload}
          manualVirtualAccount={props?.manualVirtualAccount}
          previewMode
          headerText="Updated Account Details"
        />

        <div className="w-full h-auto  p-padding-md rounded-border-radius-md bg-primary-card custom-boxShadow">
          <div className=" text-text-secondary">
            <p className="text-text-primary font-semibold text-font-md">
              Archive Account Details
            </p>
            <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
              This account will become inactive.
            </p>
            <div className=" border border-primary-bg w-full my-margin-sm"></div>
            <div className="pb-padding-sm">
              <h5 className="text-text-primary font-semibold mb-margin-md text-font-md">
                {props?.payload?.pan_no && props?.payload?.gstin_detail
                  ? "Beneficiary PAN & GSTIN Details"
                  : " PAN Details"}
              </h5>
              <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                {props?.payload?.pan_no}
              </span>
              <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                PAN details
              </p>

              {props?.payload?.gstin_detail ? (
                <div className=" mt-margin-sm">
                  <span className="text-text-primary font-normal text-font-md">
                    {props?.payload?.gstin_detail}
                  </span>
                  <p className="text-text-secondary font-normal text-font-xs">
                    GST details
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className=" border border-primary-bg w-full "></div>
            <div className=" pt-padding-sm">
              <h5 className="text-text-primary font-semibold mb-margin-md text-font-md capitalize">
                Bank details
              </h5>
              <div className="flex flex-row justify-between items-center  mb-margin-sm">
                <div className="flex flex-col gap-y-gap-xs">
                  <span className="text-text-primary text-font-md font-normal ">
                    {formatAccountNumber(props?.payload?.old_bank_account)}
                  </span>
                  <p className="text-text-secondary text-font-xs font-normal">
                    Account number
                  </p>
                </div>
                <div className="flex items-center justify-between">
                  <CommonBankLogo
                    ifsc={props?.payload?.old_ifsc_code}
                    type="pill"
                    variant="big"
                  />
                </div>
              </div>
              <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                {props?.payload?.old_ifsc_code}
              </span>
              <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                {globalText?.IFSC}
              </p>
              {props?.payload?.old_virtual_account_type?.length !==
                GlobalConfiguration?.lengthCheckZero && (
                <div className="mt-margin-sm">
                  <span className="text-text-primary font-normal text-font-md">
                    {props?.payload?.old_virtual_account_type === "automated"
                      ? "Auto detected"
                      : "Manually created"}
                  </span>
                  <p className="text-text-secondary mt-margin-xs text-font-xs font-normal">
                    Virtual account
                  </p>
                </div>
              )}
            </div>
            <div className=" border border-primary-bg my-margin-sm w-full"></div>
            <div>
              <h5 className="text-text-primary font-semibold mb-margin-md text-font-md ">
                Contact Details
              </h5>
              <span className="capitalize text-text-primary font-normal mt-margin-sm text-font-md">
                {props?.payload?.name}
              </span>
              <p className="text-text-secondary font-normal mb-margin-sm mt-margin-xs text-font-xs">
                {props?.payload?.name === props?.payload?.legal_name
                  ? "Account name - Using legal name"
                  : "Account name"}
              </p>
              <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                +91 {props?.payload?.contact_no}
              </span>
              <p className="text-text-secondary font-normal my-margin-sm mt-margin-xs text-font-xs">
                Contact number
              </p>

              <p
                id="email-id-firstLetter"
                className=" text-text-primary font-normal mt-margin-sm overflow-ellipsis w-width-almost-full text-font-md overflow-hidden whitespace-nowrap "
              >
                {linkIdentifier(props?.payload?.email_id)}
              </p>

              <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                Email ID
              </p>
            </div>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default ReimbursementEditConfirm;
